export default __webpack_public_path__ + "static/media/DemiLovelace.388f1dc2.png";